var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"theme-switcher",on:{"click":_vm.handleClick}},_vm._l((_vm.themes),function(theme,i){return _c('span',{key:i,staticClass:"theme-switcher__dot",class:{
      'theme-switcher__dot--is-active': _vm.isActive(theme),
      'theme-switcher__dot--is-animating': _vm.isAnimating
    },style:({
      borderColor: ("var(--" + theme),
      backgroundColor: ("var(--" + theme + ")")
    }),attrs:{"tabindex":"-1"},on:{"transitionend":_vm.handleTransitionEnd}})}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0912b7c4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Navigation/ThemeSwitcher.vue
// module id = null
// module chunks = 